import definitions from "../../definitions";
import QuestKill from "../../game/quest/QuestKill";
import {iswebfont, locale, resizeLabelToFitText, sensitiveUpperCase} from "../../utils";
import TextFormat from "../TextFormat";
import QuestTrackerPopup from "./QuestTrackerPopup";
import {json, texture} from "p3";
import QuestFetch from "../../game/quest/QuestFetch";

export default class QuestTrackerProgressPopup extends QuestTrackerPopup {
    /**
     * @param {Quest} quest
     */
    constructor(quest) {
        super(QuestTrackerPopup.TYPE_PROGRESS, quest);

        this._progress = 0;
        this._progressBarFillWidth = 316;
        this._progressBarFillSmoothing = 12;

        this._nameLabel = null;
        this._progressBar = null;
    }

    init() {
        super.init();

        if (!iswebfont()) {
            this._nameLabel = new PIXI.BitmapText("", {
                fontName: "Alghera Pro",
                fontSize: 28,
                align: "left",
                tint: 0x000000
            });
        } else {
            this._nameLabel = new PIXI.Text("", {
                fontFamily: "FredFredBurger",
                fontSize: 28,
                align: "left",
                fill: 0x0
            });
        }
        this._nameLabel.position.set(86, !iswebfont() ? 44 : 41);
        this._nameLabel.anchor.set(0, 1);
        this.addChild(this._nameLabel);

        this._progressBar = new PIXI.Container();
        this._progressBar.position.set(84, 55);
        this._progressBar.scale.set(0.65);
        this.addChild(this._progressBar);

        this._progressBar.fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._progressBar.fill.position.set(6, 4);
        this._progressBar.fill.width = 0;
        this._progressBar.fill.height = 14;
        this._progressBar.fill.tint = 0x4BB6B5;
        this._progressBar.addChild(this._progressBar.fill);

        this._progressBar.frame = new PIXI.Sprite(texture("progress_bar_frame"));
        this._progressBar.addChild(this._progressBar.frame);

        const barIcon = new PIXI.Sprite(texture(this._quest.icon));
        barIcon.width = barIcon.height = 35;
        barIcon.anchor.set(0, 1);
        //barIcon.scale.set(1);
        barIcon.x = this._progressBar.x - 10;
        barIcon.y = this._progressBar.y + this._progressBar.height + 10;
        this.addChild(barIcon);

        if (!iswebfont()) {
            this._progressLabel = new PIXI.BitmapText(String(this._quest.value) + '/' + String(this._quest.target), {
                fontName: "Alghera Pro",
                fontSize: 24,
                align: "left",
                tint: 0x702311,
                maxWidth: 250
            });
        } else {
            this._progressLabel = new PIXI.Text(String(this._quest.value) + '/' + String(this._quest.target), {
                fontFamily: "FredFredBurger",
                fontSize: 24,
                align: "left",
                fill: 0x702311,
                wordWrap: true,
                wordWrapWidth: 250
            });
        }
        this._progressLabel.anchor.set(0, 0.5);
        this._progressLabel.x = this._progressBar.x + this._progressBar.width + 5;
        this._progressLabel.y = this._progressBar.y + (this._progressBar.height/2);
        this.addChild(this._progressLabel);

        this.setProgress(this._quest.progress, false);
    }

    update() {
        const target = this._progress * this._progressBarFillWidth;
        const ease = (target - this._progressBar.fill.width) * this._progressBarFillSmoothing;
        this._progressBar.fill.width += ease * window.dt;
    }

    /**
     * @param {number} value
     * @param {boolean} [animate=false]
     */
    setProgress(value, animate = false) {
        this._nameLabel.text = sensitiveUpperCase(this.getNameString());
        this._nameLabel.scale.set(1);

        resizeLabelToFitText(this._nameLabel, 360);

        this._progress = value;

        if (!animate) {
            this._progressBar.fill.width = value * this._progressBarFillWidth;
        }
        this._progressLabel.text = String(this._quest.value) + '/' + String(this._quest.target);
    }

    /**
     * @return {string}
     */
    getNameString() {
        return locale(this._quest.name);
    }

    /**
     * @return {number}
     */
    get progress() {
        return this._progress;
    }
}